import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import { FaInfoCircle, FaRedo } from 'react-icons/fa';

import Button from 'v3/components/Button';
import Pagination from 'v3/components/DataTable/Pagination';
import Text from 'v3/components/Text';

import IntegrationLogItem from '../IntegrationLogItem';
import { ICONS, getIntegrationSummary } from '../utils';
import * as Styled from './styles';

function IntegrationLogGroup({ groupKey, label, logs, perPage, onResend }) {
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [resending, setResending] = useState(false);
  const summary = getIntegrationSummary(logs);
  const SummaryIcon = ICONS[summary.variant] || FaInfoCircle;
  const hasLogs = logs.length > 0;
  const lastPage = Math.max(Math.ceil(logs.length / perPage), 1);
  const pageLogs = logs.slice((page - 1) * perPage, page * perPage);
  const bodyId = `integration-logs-${groupKey}`;

  async function handleResend() {
    setResending(true);
    try {
      await onResend();
    } finally {
      setResending(false);
    }
  }

  return (
    <Styled.Group>
      <Styled.GroupHeader>
        <Styled.GroupToggle
          type="button"
          onClick={() => setOpen((prev) => !prev)}
          disabled={!hasLogs}
          aria-expanded={open}
          aria-controls={bodyId}
        >
          <Text type="regular" color="dark" weight={500}>
            {label}
          </Text>
          <Styled.Summary>
            <Styled.IconWrapper $variant={summary.variant} $size={16} aria-hidden="true">
              <SummaryIcon />
            </Styled.IconWrapper>
            <Text type="regular" color="gray">
              {summary.text}
            </Text>
            {hasLogs && <Styled.Chevron $open={open} aria-hidden="true" />}
          </Styled.Summary>
        </Styled.GroupToggle>
        {onResend && hasLogs && (
          <Styled.ResendAction>
            <Button
              variant="primary"
              outlined
              size="sm"
              loading={resending}
              onClick={handleResend}
              aria-label={`Reenviar integração ${label}`}
            >
              <Styled.ResendLabel>
                <FaRedo aria-hidden="true" />
                Reenviar
              </Styled.ResendLabel>
            </Button>
          </Styled.ResendAction>
        )}
      </Styled.GroupHeader>
      <Collapse in={open && hasLogs}>
        <div id={bodyId}>
          <Styled.GroupBody>
            <Styled.List>
              {pageLogs.map((log) => (
                <IntegrationLogItem key={log.id} log={log} />
              ))}
            </Styled.List>
            {lastPage > 1 && (
              <div className="d-flex justify-content-center mt-2">
                <Pagination currentPage={page} pages={lastPage} onPageChanged={setPage} />
              </div>
            )}
          </Styled.GroupBody>
        </div>
      </Collapse>
    </Styled.Group>
  );
}

export default IntegrationLogGroup;
